import { useAuth } from '@clerk/clerk-react';
import { useAppSelector } from './useAppSelector';
import { selectUser } from '../../slices/user/userSlice';
import { GROUPS } from '../constants/groups';

export const useCheckPermission = () => {
  const currentUser = useAppSelector(selectUser);
  const { has } = useAuth();
  return (permission: string) => {
    console.log('permission =', permission);
    if (has({ permission: permission })) {
      console.log('has regular permission');
      return true;
    } else {
      console.log(has({ permission: 'org:' + permission }));
      return (
        has({ permission: 'org:' + permission }) ||
        currentUser?.groups?.some((group) => group.name === GROUPS.COMPANY_ADMIN)
      );
    }
  };
};
